import { render } from "./DrinkTour.vue?vue&type=template&id=1fabfc2e"
const script = {}

import exportComponent from "../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/package/DrinkTour.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1fabfc2e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1fabfc2e', __exports__)) {
    api.reload('1fabfc2e', __exports__)
  }
  
  module.hot.accept("./DrinkTour.vue?vue&type=template&id=1fabfc2e", () => {
    api.rerender('1fabfc2e', render)
  })

}


export default __exports__